(() => {
  const legacyHashes = {
    '#story': '#flavors',
    '#flavor': '#why-forj',
  };
  if (legacyHashes[location.hash]) {
    history.replaceState(null, '', legacyHashes[location.hash]);
  }

  const story = document.querySelector('.scroll-story');
  const sticky = document.querySelector('.story-sticky');
  const siteHeader = document.querySelector('.site-header');
  const beats = [...document.querySelectorAll('.story-beat')];
  const products = [...document.querySelectorAll('.flavor-product')];
  const fruitArtwork = [...document.querySelectorAll('[data-fruit-art]')];
  const pickerButtons = [...document.querySelectorAll('[data-flavor-index]')];
  const flavorPicker = document.querySelector('.flavor-picker');
  const storyNumber = document.querySelector('.story-number');
  const storyFlavor = document.querySelector('.story-flavor');
  const flavorIndexSection = document.querySelector('.flavor-section');
  const flavorIndexSticky = document.querySelector('.flavor-sticky');
  const flavorIndex = document.querySelector('.flavor-index');
  const flavorRows = [...document.querySelectorAll('[data-flavor-row]')];
  const menu = document.querySelector('[data-forj-menu]');
  const productPage = document.querySelector('[data-forj-product]');
  const flavorQuiz = document.querySelector('[data-flavor-quiz]');
  const flightPage = document.querySelector('[data-forj-flight]');
  const pageScroller = document.querySelector('.page-wrapper');
  const firstOrderGift = document.querySelector('[data-first-order-gift]');
  const firstOrderGiftClose = document.querySelector('[data-first-order-gift-close]');
  const firstOrderGiftCopy = document.querySelector('[data-first-order-gift-copy]');
  const firstOrderGiftShop = document.querySelector('[data-first-order-gift-shop]');

  const flavors = [
    { name: 'PINEAPPLE\nMANGO', color: '#ffd744' },
    { name: 'GUMMY PEACH\nRING', color: '#f5a07f' },
    { name: 'LEMONADE\nSLUSH', color: '#f8e466' },
  ];
  const flavorIndexColors = ['#40c1c7', '#f0a087', '#ffd744', '#ef8f76'];
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lastActiveFlavorIndex = -1;
  let mobileBenefitsMode;
  let lastViewportWidth = innerWidth;

  function usesPageScroller() {
    return innerWidth >= 990 && pageScroller;
  }

  function getViewportHeight() {
    return usesPageScroller() ? pageScroller.clientHeight : (window.visualViewport?.height || innerHeight);
  }

  function getViewportTop() {
    return usesPageScroller() ? pageScroller.getBoundingClientRect().top : 0;
  }

  function syncMobileViewportHeight() {
    if (innerWidth > 800) {
      document.documentElement.style.removeProperty('--forj-mobile-viewport-height');
      return;
    }
    const viewportHeight = window.visualViewport?.height || innerHeight;
    document.documentElement.style.setProperty('--forj-mobile-viewport-height', `${viewportHeight}px`);
  }

  function getScrollTop() {
    return usesPageScroller() ? pageScroller.scrollTop : scrollY;
  }

  function getElementScrollTop(element) {
    return getScrollTop() + element.getBoundingClientRect().top - getViewportTop();
  }

  function hexToRgb(hex) {
    const value = Number.parseInt(hex.slice(1), 16);
    return { r: value >> 16, g: (value >> 8) & 255, b: value & 255 };
  }

  function blendColors(from, to, amount) {
    const a = hexToRgb(from);
    const b = hexToRgb(to);
    const mix = (start, end) => Math.round(start + (end - start) * amount);
    return `rgb(${mix(a.r, b.r)} ${mix(a.g, b.g)} ${mix(a.b, b.b)})`;
  }

  function updateHeader() {
    siteHeader?.classList.toggle('is-scrolled', getScrollTop() > 40);
  }

  function setupFirstOrderGift() {
    if (!firstOrderGift) return;
    const storageKey = 'forj-first15-gift-dismissed';
    const dismissDuration = 14 * 24 * 60 * 60 * 1000;
    let dismissedAt = 0;

    try {
      dismissedAt = Number(localStorage.getItem(storageKey)) || 0;
    } catch {
      // The gift can still be shown when browser storage is unavailable.
    }
    if (Date.now() - dismissedAt < dismissDuration) return;

    const dismiss = () => {
      firstOrderGift.classList.remove('is-visible');
      try {
        localStorage.setItem(storageKey, String(Date.now()));
      } catch {
        // Closing should always work, even if storage is blocked.
      }
      setTimeout(() => { firstOrderGift.hidden = true; }, reducedMotion ? 0 : 280);
    };

    const copyCode = async () => {
      try {
        await navigator.clipboard.writeText('FIRST15');
      } catch {
        const field = document.createElement('textarea');
        field.value = 'FIRST15';
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.append(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }
      if (firstOrderGiftCopy) {
        firstOrderGiftCopy.textContent = 'Code copied';
        setTimeout(() => { firstOrderGiftCopy.textContent = 'Copy FIRST15'; }, 1800);
      }
    };

    firstOrderGiftClose?.addEventListener('click', dismiss);
    firstOrderGiftShop?.addEventListener('click', (event) => {
      const destination = firstOrderGiftShop.getAttribute('href');
      if (!destination?.startsWith('#') || reducedMotion) {
        dismiss();
        return;
      }
      event.preventDefault();
      dismiss();
      setTimeout(() => {
        document.querySelector(destination)?.scrollIntoView({ behavior: 'smooth' });
        history.replaceState(null, '', destination);
      }, 260);
    });
    firstOrderGiftCopy?.addEventListener('click', copyCode);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && firstOrderGift.classList.contains('is-visible')) dismiss();
    });

    setTimeout(() => {
      firstOrderGift.hidden = false;
      // Force one layout pass so the card reliably animates in across Safari,
      // Chrome, and browsers that throttle requestAnimationFrame on load.
      void firstOrderGift.offsetWidth;
      firstOrderGift.classList.add('is-visible');
    }, reducedMotion ? 400 : 1400);
  }

  function setActiveFlavor(index) {
    if (index === lastActiveFlavorIndex) return;
    beats.forEach((beat, itemIndex) => beat.classList.toggle('is-active', itemIndex === index));
    fruitArtwork.forEach((art, itemIndex) => art.classList.toggle('is-active', itemIndex === index));
    pickerButtons.forEach((button, itemIndex) => {
      const active = itemIndex === index;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    if (storyNumber) storyNumber.textContent = `0${index + 1} — 04`;
    if (storyFlavor) storyFlavor.textContent = flavors[index].name;

    if (innerWidth <= 800 && index !== lastActiveFlavorIndex && flavorPicker && pickerButtons[index]) {
      const button = pickerButtons[index];
      const left = button.offsetLeft - (flavorPicker.clientWidth - button.offsetWidth) / 2;
      // The page is already animating vertically here. Keeping this immediate
      // avoids two simultaneous smooth animations on mobile Safari.
      flavorPicker.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
    }
    lastActiveFlavorIndex = index;
  }

  function updateStory() {
    if (!story || !sticky) return;
    const rect = story.getBoundingClientRect();
    const viewportHeight = getViewportHeight();
    const scrollDistance = Math.max(1, story.offsetHeight - viewportHeight);
    const progress = clamp(-(rect.top - getViewportTop()) / scrollDistance);
    const scaledProgress = progress * flavors.length;
    const activeIndex = Math.min(flavors.length - 1, Math.floor(scaledProgress));
    const localProgress = scaledProgress - activeIndex;
    const handoff = activeIndex < flavors.length - 1 ? clamp((localProgress - 0.68) / 0.32) : 0;

    // Keep copy, active tab, and artwork on one shared state. During the
    // product handoff they switch together when the incoming tub becomes the
    // dominant visual, so no part of the story can run one flavor ahead.
    const displayIndex = handoff >= 0.5
      ? Math.min(activeIndex + 1, flavors.length - 1)
      : activeIndex;
    setActiveFlavor(displayIndex);
    sticky.style.setProperty('--progress', progress.toFixed(4));
    sticky.style.backgroundColor = blendColors(
      flavors[activeIndex].color,
      flavors[Math.min(activeIndex + 1, flavors.length - 1)].color,
      handoff,
    );

    const handoffDistance = viewportHeight * 1.12;
    products.forEach((product, index) => {
      let y;
      if (reducedMotion) y = index === activeIndex ? 0 : index < activeIndex ? handoffDistance : -handoffDistance;
      else if (index < activeIndex) y = handoffDistance;
      else if (index === activeIndex) y = handoff * handoffDistance;
      else if (index === activeIndex + 1) y = (handoff - 1) * handoffDistance;
      else y = -handoffDistance;
      product.style.transform = `translate3d(0, ${y}px, 0) scale(1)`;
    });
    sticky.style.setProperty('--shadow-scale', String(0.84 + handoff * 0.12));
  }

  function scrollToFlavor(index) {
    if (!story) return;
    const scrollDistance = Math.max(1, story.offsetHeight - getViewportHeight());
    const top = getElementScrollTop(story) + scrollDistance * (index / flavors.length + 0.08);
    const scrollRoot = usesPageScroller() ? pageScroller : window;
    scrollRoot.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });
  }

  function updateFlavorIndex() {
    if (!flavorIndexSection || !flavorIndexSticky || !flavorRows.length) return;

    const rect = flavorIndexSection.getBoundingClientRect();
    const scrollDistance = Math.max(1, flavorIndexSection.offsetHeight - getViewportHeight());
    const progress = clamp(-(rect.top - getViewportTop()) / scrollDistance);
    const scaledProgress = progress * flavorRows.length;
    const activeIndex = Math.min(flavorRows.length - 1, Math.floor(scaledProgress));
    const localProgress = clamp(scaledProgress - activeIndex);
    const nextIndex = Math.min(activeIndex + 1, flavorRows.length - 1);

    if (innerWidth <= 800) {
      const mobileActiveIndex = Math.min(
        flavorRows.length - 1,
        Math.floor(progress * flavorRows.length),
      );
      flavorRows.forEach((row, index) => {
        const active = index === mobileActiveIndex;
        row.classList.add('is-revealed');
        row.classList.toggle('is-active', active);
        row.classList.remove('is-before', 'is-after');
        row.style.removeProperty('--row-x');
        row.style.removeProperty('--row-y');
        row.style.removeProperty('--row-opacity');
        row.style.removeProperty('--row-scale');
        if (active) {
          row.setAttribute('aria-current', 'true');
        } else {
          row.removeAttribute('aria-current');
        }
        row.removeAttribute('aria-hidden');
        if (row.matches('a')) row.removeAttribute('tabindex');
      });
      flavorIndexSticky.style.backgroundColor = '';
      flavorIndexSticky.style.setProperty('--index-progress', progress.toFixed(4));
      flavorIndexSticky.style.setProperty('--index-settle', '0px');
      return;
    }

    flavorRows.forEach((row, index) => {
      row.classList.toggle('is-revealed', reducedMotion || index <= activeIndex);
      row.classList.toggle('is-active', index === activeIndex);
      row.classList.remove('is-before', 'is-after');
      if (index === activeIndex) row.setAttribute('aria-current', 'true');
      else row.removeAttribute('aria-current');
      row.removeAttribute('aria-hidden');
      if (row.matches('a')) row.removeAttribute('tabindex');
    });
    flavorIndexSticky.style.setProperty('--index-progress', progress.toFixed(4));
    flavorIndexSticky.style.backgroundColor = blendColors(
      flavorIndexColors[activeIndex],
      flavorIndexColors[nextIndex],
      clamp((localProgress - 0.84) / 0.16),
    );

    flavorIndexSticky.style.setProperty('--index-settle', '0px');
  }

  function setupMobileBenefitReveals(force = false) {
    if (!flavorIndexSection || !flavorIndexSticky || !flavorRows.length) return;
    const nextMode = innerWidth <= 800 ? 'mobile' : 'desktop';
    if (!force && mobileBenefitsMode === nextMode) return;
    mobileBenefitsMode = nextMode;

    flavorIndexSection.classList.remove('is-mobile-reveal-ready');
    flavorIndexSticky.style.backgroundColor = '';
    flavorIndexSticky.style.setProperty('--index-settle', '0px');
    flavorIndexSticky.style.setProperty('--benefit-rotation', '0deg');
    flavorRows.forEach((row) => {
      row.classList.add('is-revealed');
      row.classList.remove('is-active', 'is-before', 'is-after', 'is-in-view');
      row.style.removeProperty('--row-x');
      row.style.removeProperty('--row-y');
      row.style.removeProperty('--row-opacity');
      row.style.removeProperty('--row-scale');
      row.removeAttribute('aria-current');
      row.removeAttribute('aria-hidden');
      if (row.matches('a')) row.removeAttribute('tabindex');
    });
  }

  function closeMenu() {
    document.body.classList.remove('is-menu-open', 'has-open-panel');
    menu?.setAttribute('aria-hidden', 'true');
  }

  document.querySelector('[data-forj-menu-open]')?.addEventListener('click', () => {
    document.body.classList.add('is-menu-open', 'has-open-panel');
    menu?.setAttribute('aria-hidden', 'false');
    menu?.querySelector('[data-forj-panel-close]')?.focus();
  });
  document.querySelectorAll('[data-forj-panel-close]').forEach((button) => button.addEventListener('click', closeMenu));
  document.querySelectorAll('.mobile-menu-links a').forEach((link) => link.addEventListener('click', closeMenu));
  pickerButtons.forEach((button) => {
    button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
    button.addEventListener('click', () => scrollToFlavor(Number(button.dataset.flavorIndex)));
  });
  addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMenu();
    if (document.body.classList.contains('is-zoom-open')) {
      document.body.classList.remove('is-zoom-open', 'has-open-panel');
      document.querySelector('[data-product-zoom-modal]')?.setAttribute('aria-hidden', 'true');
      document.querySelector('[data-product-zoom]')?.focus();
    }
  });

  if (productPage) {
    const productForm = document.querySelector('#forj-product-form');
    const quantityInput = productForm?.querySelector('input[name="quantity"]');
    const minusButton = document.querySelector('[data-quantity-minus]');
    const plusButton = document.querySelector('[data-quantity-plus]');
    const formStatus = document.querySelector('[data-product-form-status]');
    const addLabel = document.querySelector('[data-add-label]');
    const addButton = productForm?.querySelector('button[type="submit"]');
    const mobileAdd = document.querySelector('[data-mobile-add]');
    const mobileBar = document.querySelector('.mobile-purchase-bar');
    const buySection = document.querySelector('.product-buy');
    const zoomModal = document.querySelector('[data-product-zoom-modal]');
    const shippingCard = document.querySelector('[data-two-tub-shipping]');
    const shippingTitle = shippingCard?.querySelector('[data-two-tub-shipping-title]');
    const shippingCount = shippingCard?.querySelector('[data-two-tub-shipping-count]');
    const shippingNote = shippingCard?.querySelector('[data-two-tub-shipping-note]');
    const shippingProgress = shippingCard?.querySelector('[data-two-tub-shipping-progress]');

    const updateTwoTubShipping = (cart) => {
      if (!shippingCard || !cart) return;
      const tubCount = Math.min(2, Number(cart.item_count) || 0);
      shippingCard.style.setProperty('--shipping-progress', `${tubCount * 50}%`);
      if (shippingProgress) shippingProgress.style.width = `${tubCount * 50}%`;
      if (shippingCount) shippingCount.textContent = `${tubCount} / 2`;

      if (tubCount >= 2) {
        if (shippingTitle) shippingTitle.textContent = 'Free shipping unlocked';
        if (shippingNote) shippingNote.textContent = 'You have two or more tubs in your bag—shipping is on us.';
      } else if (tubCount === 1) {
        if (shippingTitle) shippingTitle.textContent = 'One more tub ships free';
        if (shippingNote) shippingNote.textContent = 'Add any second tub to your bag to unlock free shipping.';
      } else {
        if (shippingTitle) shippingTitle.textContent = 'Free shipping on any 2 tubs';
        if (shippingNote) shippingNote.textContent = 'Add any two tubs to your bag and shipping is on us.';
      }
    };

    const refreshTwoTubShipping = async () => {
      if (!shippingCard) return;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        if (response.ok) updateTwoTubShipping(await response.json());
      } catch {
        // Keep the useful two-tub message visible if cart status cannot be loaded.
      }
    };

    const setQuantity = (value) => {
      if (!quantityInput) return;
      const quantity = clamp(Number.parseInt(value, 10) || 1, 1, 9);
      quantityInput.value = String(quantity);
      if (minusButton) minusButton.disabled = quantity === 1;
    };

    minusButton?.addEventListener('click', () => setQuantity(Number(quantityInput?.value) - 1));
    plusButton?.addEventListener('click', () => setQuantity(Number(quantityInput?.value) + 1));
    quantityInput?.addEventListener('change', () => setQuantity(quantityInput.value));

    productForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!addButton || addButton.disabled) return;
      addButton.disabled = true;
      mobileAdd?.setAttribute('disabled', '');
      if (addLabel) addLabel.textContent = 'Adding…';
      if (formStatus) formStatus.textContent = 'Adding this flavor to your bag…';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(productForm),
        });
        if (!response.ok) throw new Error('The product could not be added.');

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        const cart = await cartResponse.json();
        document.querySelectorAll('.header-cart span').forEach((count) => {
          count.textContent = String(cart.item_count);
        });
        updateTwoTubShipping(cart);
        if (addLabel) addLabel.textContent = 'Added';
        if (formStatus) {
          formStatus.textContent = 'Added to your bag. Use “Bag” at the top whenever you’re ready.';
          formStatus.classList.add('is-emphasized');
        }
        setTimeout(() => {
          if (addLabel) addLabel.textContent = 'Add to cart';
        }, 1800);
      } catch (error) {
        if (addLabel) addLabel.textContent = 'Try again';
        if (formStatus) formStatus.textContent = error.message || 'Something went wrong. Please try again.';
      } finally {
        addButton.disabled = false;
        mobileAdd?.removeAttribute('disabled');
      }
    });

    mobileAdd?.addEventListener('click', () => productForm?.requestSubmit());
    refreshTwoTubShipping();
    if (buySection && mobileBar && 'IntersectionObserver' in window) {
      const purchaseObserver = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        mobileBar.classList.toggle('is-visible', passed);
      });
      purchaseObserver.observe(buySection);
    }

    document.querySelector('[data-product-zoom]')?.addEventListener('click', () => {
      closeMenu();
      zoomModal?.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-zoom-open', 'has-open-panel');
      document.querySelector('[data-product-zoom-close]')?.focus();
    });
    document.querySelector('[data-product-zoom-close]')?.addEventListener('click', () => {
      zoomModal?.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-zoom-open', 'has-open-panel');
      document.querySelector('[data-product-zoom]')?.focus();
    });

    setQuantity(quantityInput?.value);
  }

  if (flavorQuiz) {
    const productDataElement = document.querySelector('[data-flavor-finder-products]');
    const productData = productDataElement ? JSON.parse(productDataElement.textContent) : {};
    const questions = [...document.querySelectorAll('[data-quiz-question]')];
    const questionsWrap = document.querySelector('[data-quiz-questions]');
    const result = document.querySelector('[data-quiz-result]');
    const progressLabel = document.querySelector('[data-quiz-progress-label]');
    const progressBar = document.querySelector('[data-quiz-progress-bar]');
    const resultName = document.querySelector('[data-quiz-result-name]');
    const resultCopy = document.querySelector('[data-quiz-result-copy]');
    const resultImage = document.querySelector('[data-quiz-result-image]');
    const resultFruit = document.querySelector('[data-quiz-result-fruit]');
    const resultLink = document.querySelector('[data-quiz-result-link]');
    const quizPanel = document.querySelector('.quiz-panel');
    const scores = Object.fromEntries(Object.keys(productData).map((key) => [key, 0]));
    let answers = [];
    let step = 0;

    const showQuizStep = () => {
      questions.forEach((question, index) => {
        question.hidden = index !== step;
      });
      if (progressLabel) progressLabel.textContent = `0${step + 1} / 0${questions.length}`;
      if (progressBar) progressBar.style.width = `${((step + 1) / questions.length) * 100}%`;
      questions[step]?.querySelector('button')?.focus();
    };

    const showQuizResult = () => {
      const resultKey = Object.keys(scores).sort((first, second) => {
        const difference = scores[second] - scores[first];
        return difference || answers.lastIndexOf(second) - answers.lastIndexOf(first);
      })[0];
      const match = productData[resultKey];
      if (!match) return;

      if (questionsWrap) questionsWrap.hidden = true;
      if (result) result.hidden = false;
      if (progressLabel) progressLabel.textContent = 'Your match';
      if (progressBar) progressBar.style.width = '100%';
      if (quizPanel) quizPanel.style.setProperty('--quiz-accent', match.accent);
      if (resultName) resultName.textContent = match.name;
      if (resultCopy) resultCopy.textContent = match.tagline;
      if (resultImage) resultImage.src = match.image;
      if (resultFruit) resultFruit.src = match.fruit;
      if (resultLink) resultLink.href = match.url;
      resultLink?.focus();
    };

    document.querySelectorAll('[data-quiz-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.quizChoice;
        if (!(key in scores)) return;
        scores[key] += 1;
        answers.push(key);
        if (step < questions.length - 1) {
          step += 1;
          showQuizStep();
        } else {
          showQuizResult();
        }
      });
    });

    document.querySelector('[data-quiz-restart]')?.addEventListener('click', () => {
      Object.keys(scores).forEach((key) => { scores[key] = 0; });
      answers = [];
      step = 0;
      if (result) result.hidden = true;
      if (questionsWrap) questionsWrap.hidden = false;
      quizPanel?.style.removeProperty('--quiz-accent');
      showQuizStep();
    });
  }

  if (flightPage) {
    const flightButton = document.querySelector('[data-flight-add]');
    const flightLabel = document.querySelector('[data-flight-add-label]');
    const flightStatus = document.querySelector('[data-flight-status]');
    flightButton?.addEventListener('click', async () => {
      if (flightButton.disabled) return;
      const variantId = Number(flightButton.dataset.variantId);
      if (!variantId) return;

      flightButton.disabled = true;
      if (flightLabel) flightLabel.textContent = 'Adding the Flight…';
      if (flightStatus) flightStatus.textContent = 'Building your FORJ Flight…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        });
        if (!response.ok) throw new Error('The full Flight could not be added.');

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        const cart = await cartResponse.json();
        document.querySelectorAll('.header-cart span').forEach((count) => {
          count.textContent = String(cart.item_count);
        });
        if (flightLabel) flightLabel.textContent = 'Flight added';
        if (flightStatus) {
          flightStatus.textContent = 'The $59.99 Flight is in your bag—one tub of each flavor.';
          flightStatus.classList.add('is-emphasized');
        }
      } catch (error) {
        if (flightLabel) flightLabel.textContent = 'Try again';
        if (flightStatus) flightStatus.textContent = error.message || 'Something went wrong. Please try again.';
      } finally {
        flightButton.disabled = false;
      }
    });
  }

  let queued = false;
  const queueScrollUpdate = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      updateStory();
      updateFlavorIndex();
      updateHeader();
      queued = false;
    });
  };
  addEventListener('scroll', queueScrollUpdate, { passive: true });
  pageScroller?.addEventListener('scroll', queueScrollUpdate, { passive: true });
  const handleViewportResize = () => {
    const widthChanged = Math.abs(innerWidth - lastViewportWidth) > 2;
    // Mobile browsers repeatedly resize the visual viewport while their
    // address bar opens and closes. Rebuilding sticky section heights during
    // that motion causes layout jumps and flicker. Only rebuild the mobile
    // tracks when the actual layout width changes (for example, rotation).
    if (innerWidth <= 800 && !widthChanged) {
      updateHeader();
      return;
    }
    lastViewportWidth = innerWidth;
    syncMobileViewportHeight();
    setupMobileBenefitReveals();
    updateStory();
    updateFlavorIndex();
    updateHeader();
  };
  addEventListener('resize', handleViewportResize);
  addEventListener('orientationchange', handleViewportResize);

  syncMobileViewportHeight();
  setupMobileBenefitReveals(true);
  setupFirstOrderGift();
  updateStory();
  updateFlavorIndex();
  updateHeader();
})();
